import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import Farmer from '@/views/Farmer.vue';
import FarmerFifteen from '@/views/FarmerFifteen.vue';
import FarmerThirty from '@/views/FarmerThirty.vue';
import Home from '@/views/Home.vue';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/nolimit',
    name: 'No Limit',
    component: Farmer,
  },
  {
    path: '/fifteendays',
    name: '15 Days Lock',
    component: FarmerFifteen,
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
